module.exports = ['$scope', '$location', ($scope, $location) ->
  if $location.search().limit
    @limit = $location.search().limit
  else
    @limit = 10 if @limit is undefined

  $scope.$watch 'ctrl.limit', (limit) ->
    limitQuery = { limit: limit }
    $location.replace().search _.merge($location.search(), limitQuery)

  @
]
